import script from "./Terminal.vue?vue&type=script&setup=true&lang=js"
export * from "./Terminal.vue?vue&type=script&setup=true&lang=js"

import "./Terminal.vue?vue&type=style&index=0&id=a155c52e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a155c52e"]])

export default __exports__